import { Component, ReactNode } from 'react';

import { FrameMessage } from 'core/ui/Frame';

type TProps = { children: ReactNode };
type TState = { error: Error | null };

export class ErrorBoundary extends Component<TProps, TState> {
  state: TState = { error: null };

  constructor(props: TProps) {
    super(props);
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({
      error: error instanceof Error ? error : new Error(String(error)),
    });
    console.error(error, errorInfo);
  }

  render() {
    return this.state.error ? (
      <FrameMessage
        message="Something went wrong!"
        subMessage="Try to reload the app"
      />
    ) : (
      this.props.children
    );
  }
}
